module.exports = __webpack_public_path__ + "static/media/Colette King 4-Drawer Bed Base - 180x210 cm_Beige.70665373.png";